export default "__VITE_ASSET__WesEsoRi__"